import { useContext } from 'react';
import { Table } from 'antd';
import useGiveawayParticipants from './useGiveawayParticipants';
import { ThemeContext } from '../../../../../../contexts/ThemeContext';
import TableCard from '../../../../../../components/TableCard';
import TablePagination from '../../../../../../components/TablePagination';
import ActiveFiltersBar from '../../../../../../components/ActiveFiltersBar';
import TableDicaHint from '../../../../../../components/TableDicaHint';

interface IProps {
    giveawayId: number;
}

export default function GiveawayParticipants({ giveawayId }: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        columns,
        isLoading,
        tableData,
        totalParticipants,
        pagination,
        activeFilterItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        navigate,
    } = useGiveawayParticipants(giveawayId);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Clique em qualquer linha da tabela para abrir o cadastro do usuário." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={totalParticipants}
                itemName="participantes"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="app_user_id"
                    size="middle"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 800 }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            navigate(`/usuarios/aplicativo/visualizar/${record.app_user_id}`);
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={totalParticipants}
                itemName="participantes"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />
        </div>
    );
}
